import { ThemeProvider } from '@emotion/react';
import NearMeOutlined from '@mui/icons-material/NearMeOutlined';
import NotificationsIcon from '@mui/icons-material/NotificationsNoneOutlined';
import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { updateAllNotificationsUser } from 'APIs/Notification.Api';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { NormalButton } from 'components/atoms/Button';

import { useMediaQuery } from '@material-ui/core';
import InboxLists from 'components/molecules/List/InboxLists';
import Lists from 'components/molecules/List/Lists';
import AuthPopup from 'components/organisms/AuthPopup';
import {
  login,
  logout,
  selectAuth,
  updateNotification,
} from 'features/auth/authSlice';
import { selectChat } from 'features/auth/chatSlice';
import {
  Notification,
  NotificationType,
} from 'interfaces/Notification.interface';
import { useCallback, useEffect, useState } from 'react';
import Media from 'react-media';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import EarlyAccess from './../../../atoms/EarlyAccess/index';
import RewardsModal from './RewardsModal';
import {
  CustomMenu,
  CustomMenuItem,
  NavLinkRow,
  NavLinkTypography,
  ParaText,
  ParaTextDivGrid,
  Search,
  StyledBadge,
  StyledInputBase,
  colortheme,
} from './styles';

import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import { getUserData, loginUserWithEmail, updateUser } from 'APIs/AuthApi';
import {
  createTatumAccount,
  getTatumAccountDetails,
  getTatumAddress,
} from 'APIs/tatum';
import { initializeTorus, torus } from 'APIs/utils';
import { ACCESS_TOKEN } from 'constant';
import { TorusData } from 'interfaces/torus.interface';
import { wikiLink } from 'config/constants';
import CircularProgress from '@mui/material/CircularProgress';

const Header = (props: any) => {
  const isWideScreen = useMediaQuery('(max-width:930px)');

  const logo = require('assets/logo.png');
  const rightAnchor = require('assets/icons/right-arrow.svg');
  const avatarIcon = require('assets/Profile/buku_default_avatar.png');
  const personIcon = require('assets/icons/person.svg');
  const settingsIcon = require('assets/icons/settings.svg');
  const gridIcon = require('assets/icons/grid.svg');
  const [torusData, setTorusData] = useState<TorusData>();
  const [following, setFollowing] = useState<any[]>();
  const [subscribers, setSubscribers] = useState<number[]>([]);

  const history = useNavigate();

  const dispatch = useAppDispatch();
  const authState = useAppSelector(selectAuth);
  const navigate = useNavigate();
  const [userMenuState, setuserMenuState] = useState<null | HTMLElement>(null);
  const [unRead, setUnRead] = useState<boolean>(false);
  const [notificationMenuState, setNotificationMenuState] =
    useState<null | HTMLElement>(null);
  const [messageMenuState, setMessageMenuState] = useState<null | HTMLElement>(
    null
  );
  const [loader, setLoader] = useState<Boolean>(false);
  const location = useLocation();
  const creatorToken = location.search.split('token=')[1]?.split('&&')[0];
  useEffect(() => {
    if (
      authState.notificationsReceived &&
      authState.notificationsReceived.length > 0
    ) {
      const unRead = authState.notificationsReceived.some(notification => {
        return !notification.isRead;
      });
      setUnRead(unRead);
    }
  }, [authState.notificationsReceived]);

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setuserMenuState(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setuserMenuState(null);
  };

  const handleOpenNotificationMenu = async (
    event: React.MouseEvent<HTMLElement>
  ) => {
    setNotificationMenuState(event.currentTarget);
    const unReadNotifications = authState.notificationsReceived.filter(
      notification => !notification.isRead
    );
    if (unReadNotifications.length > 0) {
      dispatch(updateNotification(unReadNotifications));
      try {
        await updateAllNotificationsUser(unReadNotifications);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleCloseNotificationMenu = () => {
    setNotificationMenuState(null);
  };

  const handleOpenMessageMenu = (event: React.MouseEvent<HTMLElement>) => {
    if (authState.generalChats.length === 0) {
      navigate('/dm');
    } else {
      setMessageMenuState(event.currentTarget);
    }
  };

  const handleCloseMessageMenu = () => {
    setMessageMenuState(null);
  };

  const [openSignInModal, setOpenSignInModal] = useState<boolean>(false);
  const chatState = useAppSelector(selectChat);

  const getSubscribers = useCallback(() => {
    if (authState.subscribers) {
      setSubscribers(authState.subscribers.map(user => user.from.id));
    } else return;
    //eslint-disable-next-line
  }, [authState]);

  useEffect(() => {
    getSubscribers();
  }, [getSubscribers]);

  useEffect(() => {
    if (authState.following) {
      const authStateFollowing = authState.following.map(
        following => following.following.id
      );
      setFollowing(authStateFollowing);
    }
  }, [authState.id]); //eslint-disable-line

  useEffect(() => {
    if (authState.authenticated) {
      setOpenSignInModal(false);
      setuserMenuState(null);
    }
  }, [authState]);

  const getNotificationMessage = (notification: Notification) => {
    switch (notification.notificationType) {
      case NotificationType.LIKE:
        return `has liked your ${
          notification.backstage ? 'Backstage post' : 'NFT'
        }.`;
      case NotificationType.COMMENT:
        return `has commented on your ${
          notification.backstage ? 'Backstage post' : 'NFT'
        }.`;
      case NotificationType.CONTENT:
        return `has purchased your content.`;
      case NotificationType.FOLLOW:
        return `has followed you`;
      case NotificationType.SUBSCRIPTION:
        return `has subscribed to your content.`;
    }
  };

  const [tatumAccountBalance, setTatumAccountBalance] = useState<string>();

  const onClickLogin = async (e: Event) => {
    e.preventDefault();

    try {
      if (!torus.isInitialized) {
        await initializeTorus();
      }
      console.log('initialized torus!!');
      const torusLogin = await torus.login();
      console.log(torusLogin[0], ' == login ==');
      const userData = await torus.getUserInfo('g');

      try {
        setLoader(true);
        const res = await loginUserWithEmail(
          userData.email,
          torusLogin[0],
          window.location.origin,
          creatorToken
        );
        if (res.data.access_token) {
          localStorage.setItem(ACCESS_TOKEN, res.data.access_token);
          const userDataRes = await getUserData();

          if (!userDataRes?.tatumUserId && !userDataRes?.tatumWalletAddress) {
            const tatumAccountResponse = await createTatumAccount();
            const tatumAccountData = tatumAccountResponse.data;
            const id = tatumAccountData.id;
            const depositAddressResp = await getTatumAddress(id);
            const tatumDepositAddressData = depositAddressResp.data;
            if (
              tatumAccountData.id &&
              tatumDepositAddressData.address &&
              userDataRes
            ) {
              await updateUser({
                id: userDataRes.id,
                tatumUserId: tatumAccountData.id,
                tatumWalletAddress: tatumDepositAddressData.address,
              });
              dispatch(
                login({
                  ...userDataRes,
                  tatumUserId: tatumAccountData.id,
                  tatumWalletAddress: tatumDepositAddressData.address,
                })
              );
            }
          } else if (
            userDataRes &&
            userDataRes.tatumUserId &&
            userDataRes.tatumWalletAddress
          ) {
            dispatch(
              login({
                ...userDataRes,
              })
            );
          }
        }
      } catch (err) {
        setLoader(false);
        console.log('err', err);
        const error = err as any;
        if (error?.response.status === 403) {
          setTorusData({ torusWalletId: torusLogin[0], ...userData });
          setOpenSignInModal(true);
        } else if (error?.code === 'ERR_NOT_IMPLEMENTED') {
          await torus.cleanUp();
          window.location.reload();
          window.alert(error?.response?.data?.message);
        }
      }
    } catch (err) {
      console.log(err);
      setLoader(false);
    }
  };

  const Applogout = async () => {
    await torus.cleanUp();
    dispatch(logout());
  };

  useEffect(() => {
    const showTatumAccountBalance = async () => {
      const id = authState.tatumUserId;
      const tatumAccountBalanceResponse = await getTatumAccountDetails(id);
      const data = tatumAccountBalanceResponse.data;
      setTatumAccountBalance(data.balance.accountBalance + ' ' + data.currency);
    };
    if (authState.tatumUserId) showTatumAccountBalance();
  }, [authState.tatumUserId]);

  return (
    <>
      <ThemeProvider theme={colortheme}>
        <AppBar
          position="absolute"
          color="transparent"
          sx={{
            top: 0,
            height: '5rem',
            justifyContent: 'center',
            paddingX: '1rem',
            paddingY: '4rem',
            boxShadow: 'none',
            zIndex: '100',
          }}
        >
          <Grid
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Grid
              item
              xs={1.5}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Link to="/">
                <img
                  src={logo}
                  alt="icon"
                  style={{
                    maxWidth: '125px',
                    width: '100%',
                  }}
                />
              </Link>

              <Grid item xs={1.5}>
                <EarlyAccess
                  left={isWideScreen ? '30px' : '5px'}
                  right={isWideScreen ? '50px' : '15px'}
                />
              </Grid>

              <Grid item xs={isWideScreen ? 3.5 : 4.5}>
                <Search>
                  <StyledInputBase />
                </Search>
              </Grid>
            </Grid>

            <Media query="(max-width: 599px)">
              {matches =>
                matches ? (
                  <Grid
                    item
                    xs={4}
                    sx={{ display: 'flex', justifyContent: 'end', gap: '30px' }}
                  >
                    <IconButton
                      size="large"
                      aria-label="show 17 new notifications"
                      color="secondary"
                      sx={{ padding: 'unset' }}
                    >
                      <StyledBadge
                        overlap="circular"
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                        variant="dot"
                      >
                        <div onClick={() => history('/notification')}>
                          <NotificationsIcon sx={{ fontSize: 'larger' }} />
                        </div>
                      </StyledBadge>
                    </IconButton>
                    <IconButton
                      size="large"
                      aria-label="show 17 new notifications"
                      color="secondary"
                      sx={{ padding: 'unset' }}
                      onClick={() => history('/message')}
                    >
                      <div>
                        <NearMeOutlined
                          sx={{ fontSize: 'larger', color: '#ffffff' }}
                        />
                      </div>
                    </IconButton>
                  </Grid>
                ) : (
                  <Grid
                    item
                    xs={6}
                    sx={{
                      display: 'flex',
                      justifyContent: 'end',
                      alignItems: 'center',
                      gap: '30px',
                    }}
                  >
                    <NavLinkRow direction="row" spacing={2}>
                      <NavLinkTypography onClick={() => history('/')}>
                        Home
                      </NavLinkTypography>
                      <NavLinkTypography onClick={() => window.open(wikiLink)}>
                        Wiki
                      </NavLinkTypography>
                      <NavLinkTypography
                        onClick={() => history('/explore/otr')}
                      >
                        Explore
                      </NavLinkTypography>

                      {authState.isCreator && (
                        <NavLinkTypography onClick={() => history('/create')}>
                          Create
                        </NavLinkTypography>
                      )}
                      <NavLinkTypography
                        style={{
                          color: '#fff',
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          authState.authenticated
                            ? history('/home/backstage')
                            : setOpenSignInModal(true);
                        }}
                      >
                        Backstage
                      </NavLinkTypography>
                      <NavLinkTypography sx={{ opacity: 0.4 }}>
                        <RewardsModal>Rewards</RewardsModal>
                      </NavLinkTypography>
                    </NavLinkRow>

                    {authState.authenticated ? (
                      <>
                        <Box
                          sx={{
                            flexGrow: 0,
                            borderRadius: '15px',
                          }}
                        >
                          <IconButton
                            size="large"
                            aria-label="show 17 new notifications"
                            color="secondary"
                            sx={{ padding: 'unset' }}
                            onClick={handleOpenNotificationMenu}
                          >
                            <StyledBadge
                              overlap="circular"
                              anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                              }}
                              variant={unRead ? 'dot' : undefined}
                            >
                              <div>
                                <NotificationsIcon
                                  sx={{ fontSize: 'larger' }}
                                />
                              </div>
                            </StyledBadge>
                          </IconButton>
                          <CustomMenu
                            sx={{
                              mt: '55px',
                              position: 'absolute',
                              height: '600px',
                            }}
                            anchorEl={notificationMenuState}
                            anchorOrigin={{
                              vertical: 'top',
                              horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                              vertical: 'top',
                              horizontal: 'right',
                            }}
                            open={Boolean(notificationMenuState)}
                            onClose={handleCloseNotificationMenu}
                          >
                            <ParaTextDivGrid item xs={12}>
                              <ParaText>Today</ParaText>
                            </ParaTextDivGrid>

                            {authState.notificationsReceived &&
                            authState.notificationsReceived.length > 0 ? (
                              authState.notificationsReceived.map(
                                (value, i) => {
                                  return (
                                    <CustomMenuItem key={i}>
                                      <Lists
                                        key={value.id}
                                        user={value.from}
                                        time={'1h'}
                                        image={
                                          value.backstage?.images[0] ||
                                          value.nft?.poster ||
                                          ''
                                        }
                                        type={'first'}
                                        message={getNotificationMessage(value)}
                                      />
                                    </CustomMenuItem>
                                  );
                                }
                              )
                            ) : (
                              <CustomMenuItem>
                                No notifications available.
                              </CustomMenuItem>
                            )}
                          </CustomMenu>
                        </Box>

                        <Box sx={{ flexGrow: 0, borderRadius: '15px' }}>
                          <IconButton
                            size="large"
                            aria-label="show 17 new notifications"
                            color="secondary"
                            sx={{ padding: 'unset' }}
                            onClick={handleOpenMessageMenu}
                          >
                            <div>
                              <NearMeOutlined
                                sx={{ fontSize: 'larger', color: '#ffffff' }}
                              />
                            </div>
                          </IconButton>
                          <CustomMenu
                            sx={{ mt: '55px', position: 'absolute' }}
                            anchorEl={messageMenuState}
                            anchorOrigin={{
                              vertical: 'top',
                              horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                              vertical: 'top',
                              horizontal: 'right',
                            }}
                            open={Boolean(messageMenuState)}
                            onClose={handleCloseMessageMenu}
                          >
                            {chatState.inboxUsers
                              .filter(
                                inboxUser =>
                                  !subscribers.includes(inboxUser.user.id) &&
                                  ((following &&
                                    following.includes(inboxUser.user.id)) ||
                                    authState.generalChats.includes(
                                      inboxUser.user.id
                                    ))
                              )
                              .map((user, i) => {
                                return (
                                  <CustomMenuItem key={i}>
                                    <InboxLists
                                      verified={user.user.verified}
                                      data={user.user}
                                    />
                                  </CustomMenuItem>
                                );
                              })}
                          </CustomMenu>
                        </Box>

                        <Box sx={{ flexGrow: 0, borderRadius: '15px' }}>
                          <IconButton
                            onClick={handleOpenUserMenu}
                            sx={{ p: 0 }}
                          >
                            <Avatar
                              alt="User Avatar"
                              src={
                                authState.avatar ? authState.avatar : avatarIcon
                              }
                              sx={{ width: 50, height: 50, objectFit: 'cover' }}
                            />
                          </IconButton>
                          <CustomMenu
                            sx={{ mt: '55px', position: 'absolute' }}
                            anchorEl={userMenuState}
                            anchorOrigin={{
                              vertical: 'top',
                              horizontal: 'right',
                            }}
                            // keepMounted
                            transformOrigin={{
                              vertical: 'top',
                              horizontal: 'right',
                            }}
                            open={Boolean(userMenuState)}
                            onClose={handleCloseUserMenu}
                          >
                            <CustomMenuItem
                              onClick={() =>
                                history(`/profile/${authState.username}/feed`)
                              }
                            >
                              <Typography textAlign="right">
                                <img
                                  src={personIcon.default}
                                  alt="personIcon"
                                  width={15}
                                  height={15}
                                  style={{ marginRight: '10px' }}
                                />
                                View Profile
                                <img
                                  src={rightAnchor.default}
                                  alt="right anchor"
                                  width={10}
                                  height={10}
                                  style={{ marginLeft: '10px' }}
                                />
                              </Typography>
                            </CustomMenuItem>
                            {authState.isCreator && (
                              <CustomMenuItem
                                onClick={() => history('/invite')}
                              >
                                <Typography textAlign="right">
                                  <img
                                    src={gridIcon.default}
                                    alt="gridIcon"
                                    width={15}
                                    height={15}
                                    style={{ marginRight: '10px' }}
                                  />
                                  Invite Creators
                                  <img
                                    src={rightAnchor.default}
                                    alt="right anchor"
                                    width={10}
                                    height={10}
                                    style={{ marginLeft: '10px' }}
                                  />
                                </Typography>
                              </CustomMenuItem>
                            )}
                            <CustomMenuItem>
                              <Typography
                                textAlign="right"
                                onClick={() => navigate('/setting')}
                              >
                                <img
                                  src={settingsIcon.default}
                                  alt="settingsIcon"
                                  width={15}
                                  height={15}
                                  style={{ marginRight: '10px' }}
                                />
                                Settings
                                <img
                                  src={rightAnchor.default}
                                  alt="right anchor"
                                  width={10}
                                  height={10}
                                  style={{ marginLeft: '10px' }}
                                />
                              </Typography>
                            </CustomMenuItem>
                            <CustomMenuItem>
                              <Typography
                                textAlign="right"
                                sx={{ display: 'flex', alignItems: 'center' }}
                              >
                                <AccountBalanceWalletOutlinedIcon
                                  fontSize="small"
                                  sx={{
                                    color: 'rgba(255,255,255, 0.5)',
                                    marginRight: '10px',
                                  }}
                                />
                                {tatumAccountBalance || '0'}
                                <img
                                  src={rightAnchor.default}
                                  alt="right anchor"
                                  width={10}
                                  height={10}
                                  style={{ marginLeft: '10px' }}
                                />
                              </Typography>
                            </CustomMenuItem>

                            <CustomMenuItem onClick={Applogout}>
                              <Typography
                                textAlign="right"
                                sx={{ display: 'flex', alignItems: 'center' }}
                              >
                                <LogoutIcon
                                  fontSize="small"
                                  sx={{
                                    color: 'rgba(255,255,255, 0.5)',
                                    marginRight: '10px',
                                  }}
                                />
                                Logout
                                <img
                                  src={rightAnchor.default}
                                  alt="right anchor"
                                  width={10}
                                  height={10}
                                  style={{ marginLeft: '10px' }}
                                />
                              </Typography>
                            </CustomMenuItem>
                          </CustomMenu>
                        </Box>
                      </>
                    ) : (
                      <NormalButton color="yellow" onClick={onClickLogin}>
                        {loader ? (
                          <CircularProgress size={25} sx={{ color: 'white' }} />
                        ) : (
                          'Sign In'
                        )}
                      </NormalButton>
                    )}
                  </Grid>
                )
              }
            </Media>
          </Grid>
        </AppBar>

        <AuthPopup
          open={openSignInModal}
          setOpen={setOpenSignInModal}
          torusData={torusData}
        />
      </ThemeProvider>
    </>
  );
};

export default Header;
